module.exports = __webpack_public_path__ + "media/img/vca/nomg4-db4a428f6054c38b62aba41b338285ac.png";